export const INITIAL_OUTLET = "INITIAL_OUTLET";
export const DETAIL_OUTLET = "DETAIL_OUTLET";
export const GALLERY_MODAL = "GALLERY_MODAL";